<template>
    <div class="c-files">
        <h3 :class="{'td-line-through': deleted}">{{title}}</h3>

        <div class="c-callout no-margin" :class="( upload ) ? 'margin-b-24' : 'margin-b-40'" v-if="files.length == 0">
            <span>Nog geen bestanden gevonden…</span>
        </div>
        <div :class="( upload ) ? 'margin-b-24' : 'margin-b-40'" v-else>
            <div class="c-table c-table--translators c-table--responsive">
                <table class="c-table__element">
                    <thead>
                        <tr>
                            <th width="60%">Bestandsnaam</th>
                            <th>Grootte</th>
                            <th width="10%" v-if="!anonymous || deletable">Opties</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="file in files" :key='file.id'>
                            <td class="c-files__filename">{{file.name}}</td>
                            <td class="color-medium-gray">{{file.size | prettybytes}}</td>
                            <td>
                                <a class="c-btn c-btn--secondary c-btn--hollow c-btn--minuscule no-margin" v-if="!anonymous && downloadable" download :href="file.original_url">
                                    <svg width="14" height="14" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M19 16c.55 0 1 .45 1 1v2c0 .5107-.388.9352-.8838.9932L19 20H5c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v1h12v-1c0-.55.45-1 1-1ZM12 3c.553 0 1 .448 1 1v8l2.4-1.8c.442-.333 1.069-.242 1.4.2.332.442.242 1.069-.2 1.4l-4 3a.9993.9993 0 0 1-1.175.018l-4-2.814c-.452-.318-.561-.942-.243-1.393.318-.452.941-.561 1.393-.243l2.428 1.7098A1.0145 1.0145 0 0 1 11 12V4c0-.552.447-1 1-1Z" id="download"/></defs><use fill="currentColor" fill-rule="nonzero" xlink:href="#download"/></svg>
                                </a>
                                <button type="button" class="c-btn c-btn--secondary c-btn--hollow c-btn--minuscule no-margin" v-if="canDelete(file)" @click.prevent="deleteFile(file)">
                                    <svg width="14" height="14" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M9 11c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1v-4c0-.55.45-1 1-1Zm6 0c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1v-4c0-.55.45-1 1-1Zm3 8c0 .551-.448 1-1 1H7c-.552 0-1-.449-1-1V8h12v11ZM10 4.328c0-.155.214-.328.5-.328h3c.286 0 .5.173.5.328V6h-4V4.328ZM21 6h-5V4.328C16 3.044 14.879 2 13.5 2h-3C9.121 2 8 3.044 8 4.328V6H3c-.55 0-1 .45-1 1s.45 1 1 1h1v11c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3V8h1c.55 0 1-.45 1-1s-.45-1-1-1Z" id="trash"/></defs><use fill="currentColor" fill-rule="nonzero" xlink:href="#trash"/></svg>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <c-upload v-if="upload" :name="'file-upload'" class="margin-b-40" @input="selected" :title="'Voeg bestanden toe'"></c-upload>
    </div>
</template>

<script>
import CUpload from '@components/form/Upload';

export default {
    components: { CUpload },
    props: {
        title: {
            required: true
        },
        files: {
            type: Array,
            required: true
        },
        deletable: {
            type: Boolean,
            default: false
        },
        downloadable: {
            type: Boolean,
            default: true
        },        
        anonymous: {
            type: Boolean,
            default: false
        },
        upload: {
            type: Boolean,
            default: false
        },
        assignment: {
            type: Object,
            required: false
        },
        deleted: Boolean,
    },
    methods: {
        selected(files) {

            if ( this.assignment ) {

                let params = {
                    bestanden: files,
                    opdracht: this.assignment.id
                };

                this.$xhr.post('/api/request-detail/' + this.$route.params.id + '/file/upload/', params).then( ({result}) => {
                    this.$store.dispatch('toasts/success', {title: 'Bestand uploaden', text: 'Je bestand is geupload'});
                    this.$store.dispatch('request/addFileTranslation', { translation: this.assignment, files: result});
                }).catch( (e) => {
                    this.$store.dispatch('toasts/alert', {title: 'Bestand uploaden', text: 'Helaas konden we je bestand niet uploaden'});
                });
            }
        },
        deleteFile(file) {

            this.$store.dispatch('confirm/open', {
                text: 'Dit document wordt definitief verwijderd. Weet je zeker dat je door wilt gaan met deze actie?',
                buttons: [
                    { text: 'Ja, document verwijderen', action: (e) => { this.confirm(file); }},
                    { text: 'Nee, document behouden', action: (e) => { this.$store.dispatch('confirm/close'); }}
                ]
            });
        },

        confirm(file) {
            this.$store.dispatch('confirm/close');

            let params = {
                bestand: file.id
            };

            if ( this.assignment ) {
                params.opdracht = this.assignment.id;
            }

            this.$xhr.delete('/api/request-detail/' + this.$route.params.id + '/file/', params).then( () => {
                this.$store.dispatch('toasts/success', {title: 'Bestand verwijderen', text: 'Je bestand is verwijderd'});

                if ( this.assignment ) {
                    this.$store.dispatch('request/removeFileTranslation', { translation: this.assignment, id: file.id });
                }
                else {
                    this.$store.dispatch('request/removeFile', file.id);
                }

            }).catch( (e) => {
                console.log(e);
                this.$store.dispatch('toasts/alert', {title: 'Bestand verwijderen', text: 'Helaas konden we je bestand niet verwijderen'});
            });
        },

        canDelete(file) {
            if ( this.assignment ) {
                return file.model_id == this.assignment.id;
            }
            else {
                return this.deletable;
            }
        }
    },
    filters: {
        prettybytes(bytes) {
            const thresh = 1000;
            const units = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
            let u = -1;
            const r = 10**1;

            if (Math.abs(bytes) < thresh) {
                return bytes + ' B';
            }

            do {
                bytes /= thresh;
                ++u;
            } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);

            return bytes.toFixed(1) + ' ' + units[u];
        }
    }
}
</script>
